import request from 'api/request';

export default function updateCourse({ id, ...data }) {
  return request({ url: `/courses/${id}`, method: 'PUT', data });
}
